import styles from "./Permissions.module.css";
import { FieldsForEdit, User } from "@/types/User.interface";
import { InputAndLabelTextBox } from "@/components/input/InputAndLabelTextBox/InputAndLabelTextBox";
import { SaveButton } from "@/components/button/SaveEditCancel/SaveButton";
import { CancelButton } from "@/components/button/SaveEditCancel/CancelButton";
import { FormEditPassword } from "../FormEditPassword";
import { OverlayForNodeContent } from "../../OverlayForNodeContent/OverlayForNodeContent";
import { observer } from "mobx-react-lite";
import { useOperationModalForCurrentUsers } from "@/hooks/useOperationModal/useOperationModalForCurrentUsers";
import { userCurrentPanelState } from "@/stores/ComponentsState/UserCurrentPanelState";
import { userStore } from "@/stores/UserStore";

export const Popup = observer(() => {
  const { modalData, utilsData } = useOperationModalForCurrentUsers();

  const setPasswordData = (data: FieldsForEdit) => {
    utilsData.setNewDataAutenticatedUser(data);
  };

  return (
    modalData.openModal && (
      <OverlayForNodeContent modalData={modalData} utilsData={utilsData}>
        {userCurrentPanelState.EDIT_TYPE === "password" && (
          <FormEditPassword
            modalHide={modalData?.isHide}
            user={userStore as User}
            returnDataForSetPassword={setPasswordData}
          />
        )}
        {userCurrentPanelState.EDIT_TYPE === "fio" && (
          <>
            <InputAndLabelTextBox
              props={{
                placeholder: "",
                value: userCurrentPanelState.FIO,
                onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
                  userCurrentPanelState.setNewFio(e.target.value),
              }}
              idAndForHTML="newFio"
              labelText="Новое ФИО"
            />
            <div className={styles.modalButtons}>
              <SaveButton
                onClick={() =>
                  utilsData.setNewDataAutenticatedUser({
                    id: userStore.id as number,
                    fio: userCurrentPanelState.FIO,
                  })
                }
              >
                Изменить ФИО
              </SaveButton>
              <CancelButton onClick={modalData?.isHide}>Отменить</CancelButton>
            </div>
          </>
        )}
      </OverlayForNodeContent>
    )
  );
});
